export function getOrganisationStructuredData() {
  return {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: 'Vitalis',
    url: 'https://www.vitalis.nl',
    logo: 'https://www.vitalis.nl/img/vitalis-logo.png',
    telephone: '040 - 293 3249',
    email: 'werken@vitalisgroep.nl',
  };
}

export function getJobPostingStructuredData(data) {
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'JobPosting',
    title: data.title,
    description: data.shortDescription,
    identifier: {
      '@type': 'PropertyValue',
      name: 'ID',
      value: data.id,
    },
    datePosted: data.openingDate,
    validThrough: data.closingDate,
    employmentType: data.applicationForm.title,
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'NL',
        addressRegion:
          // 3054015 is Parc Imstenrade only Vitalis location in Limburg
          data.location?.code === '3054015' ? 'Limburg' : 'Noord-Brabant',
        addressLocality: data.locationDetails?.city,
        postalCode: data.locationDetails?.postal,
        streetAddress: data.locationDetails?.address,
      },
    },
    hiringOrganization: getOrganisationStructuredData(),
    directApply: true,
  };

  if (data.salaryScale?.minSalary) {
    schema.baseSalary = {
      '@type': 'MonetaryAmount',
      currency: 'EUR',
      minValue: data.salaryScale.minSalary,
      maxValue: data.salaryScale?.maxSalary,
    };
  }

  return schema;
}
